import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_2 = { class: "m-l-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.callBackTextVisible,
    title: "Notice",
    onCancel: _ctx.hideTextModal
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, { onClick: _ctx.hideTextModal }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (val, ind) => {
        return (_openBlock(), _createElementBlock("div", { key: ind }, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(val.author), 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(val.updatedAt), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(val.content), 1)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}